import React from "react";
import TooltipGaugeChart from "src/components/TooltipGaugeChart";
import { useTranslation } from "src/context/Translations/context";
import { CalculatePercentageType } from "../Objectives/interface";

export interface ITooltipGaugeChartMapsValue{
    title: string;
	colorActions?: string;
	colorIndicators?: string;
	colorProjects?: string;
    calculatePercentage: number;
    percentageActions: number;
    percentageIndicators: number;
    percentageProjects: number;
}

export interface ITooltipGaugeChartMaps{
    value?: ITooltipGaugeChartMapsValue;
}

const TooltipGaugeChartMaps: React.FC<ITooltipGaugeChartMaps> = ({
	value
}) => {
	const { translate } = useTranslation();

	if(!value)
		return null;


	const tooltipAction = (left: string) => (
		<TooltipGaugeChart 
			styleInlineFade={`z-index:100; left: ${left}`} // unset
			value={{
				title: translate("Ações"),
				subTitle: value.title,
				color: value.colorActions || null,
				percentage: value.percentageActions
			}}
		/>
	);
    
	const tooltipIndicators = (left: string) => (
		<TooltipGaugeChart 
			styleInlineFade={`z-index:100; left: ${left}`} // 27rem
			value={{
				title: translate("Indicadores"),
				subTitle: value.title,
				color: value.colorIndicators || null,
				percentage: value.percentageIndicators
			}}
		/>
	);

	const tooltipProjects = (left: string) => (
		<TooltipGaugeChart 
			styleInlineFade={`z-index:100; left: ${left}`} // 48rem
			value={{
				title: translate("Projetos"),
				subTitle: value.title,
				color: value.colorProjects || null,
				percentage: value.percentageProjects
			}}
		/>
	);

	const factoryTooltip = () => {
		switch (String(value.calculatePercentage)) 
		{
		case CalculatePercentageType.INDICATORS:
			return (
				<>
					{tooltipIndicators("unset")}
				</>
			);
		case CalculatePercentageType.ACTIONS:
			return (
				<>
					{tooltipAction("unset")}
				</>
			);
		case CalculatePercentageType.INDICATORS_ACTIONS:
			return (
				<>
					{tooltipAction("unset")}
					{tooltipIndicators("27rem")}
				</>
			);
		case CalculatePercentageType.PROJECTS:
			return (
				<>
					{tooltipProjects("unset")}
				</>
			);
		case CalculatePercentageType.INDICATORS_PROJECTS:
			return (
				<>
					{tooltipIndicators("unset")}
					{tooltipProjects("27rem")}
				</>
			);
		case CalculatePercentageType.PROJECTS_ACTIONS:
			return (
				<>
					{tooltipAction("unset")}
					{tooltipProjects("27rem")}
				</>
			);
		case CalculatePercentageType.INDICATORS_PROJECTS_ACTIONS:
			return (
				<>
					{tooltipAction("unset")}
					{tooltipIndicators("27rem")}
					{tooltipProjects("48rem")}
				</>
			);
		default:
			return (
				<span style={{alignSelf:"center"}}>
					{translate("Não foi possível carregar as informações")}
				</span>
			);
		}
	};

	return(
		<>
			{factoryTooltip()}
		</>
	);
};

export default TooltipGaugeChartMaps;
